import { Outlet } from "react-router";
import logo from "../assets/images/logo.svg";
import MenuItem from "../components/shared/MenuItem";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import Wrapper from "../components/layout/Account/Wrapper";
import {
  Bolt,
  CarFront,
  House,
  MapPin,
  Store,
  TableProperties,
  Users,
  Warehouse,
} from "lucide-react";

export default function MainLayout() {
  const { user } = useContext(AuthContext);
  const menus = [
    {
      id: 1,
      isActive: true,
      access: [0, 1, 2, 3, 4, 9],
      to: "/dashboard",
      name: "Dashboard",
      icon: <House size={20} />,
    },
    {
      id: 1,
      isActive: true,
      access: [0, 1, 2, 3, 4, 9],
      to: "/entries",
      name: "Entries",
      icon: <TableProperties size={20} />,
    },
    {
      id: 1,
      isActive: true,
      access: [0, 1, 2, 3, 4, 9],
      to: "/services",
      name: "Services",
      icon: <Bolt size={20} />,
    },
    {
      id: 2,
      isActive: false,
      access: [9],
      to: "/branches",
      name: "Branches",
      icon: <Store size={20} />,
    },
    {
      id: 2,
      isActive: false,
      access: [9],
      to: "/regions",
      name: "Regions",
      icon: <MapPin size={20} />,
    },
    {
      id: 2,
      isActive: false,
      access: [9],
      to: "/makes",
      name: "Makes",
      icon: <CarFront size={20} />,
    },
    {
      id: 5,
      isActive: false,
      access: [9],
      to: "/users",
      name: "Users",
      icon: <Users size={20} />,
    },
  ];
  return (
    <div className="h-screen bg-gray-100 font-toyota text-xxs">
      <div className="flex h-full">
        <div className="w-56 flex-shrink-0 bg-autoinc-orange min-h-screen shadow-r-lg text-white">
          <div className="border-b border-karimjee-dark flex items-center justify-center h-14 bg-karimjee">
            <img src={logo} alt="Logo" width={150} />
          </div>
          <div className="p-2">
            <div className="flex flex-col">
              {menus?.map((menu: any, index: number) => {
                if (menu?.access?.includes(user?.accessLevel)) {
                  return (
                    <MenuItem
                      to={menu.to}
                      icon={menu.icon}
                      key={index}
                      name={menu.name}
                      className="hidden md:block"
                    />
                  );
                }
              })}
            </div>
          </div>
          <div className="fixed bottom-0">
            <Wrapper />
          </div>
        </div>
        <div className="flex-1 w-full overflow-hidden flex flex-col">
          <div className="flex-1 overflow-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
